import { Popper } from "../Popper";

export class PopperState{

    private currentPopper : Popper;

    addOpenPopper( popper:Popper) : void{
        if(this.currentPopper != null){
            this.currentPopper.close();
            this.currentPopper=null;
        }
        this.currentPopper = popper;
    }

    disposePopper(popper: Popper) : void {
        if(this.currentPopper == popper){
            this.currentPopper = null;
        }
    }

}